import React from "react";
import { useState, useEffect } from "react";
import {
  Form,
  Button,
  Col,
  Row,
  Container,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Alert,
} from "react-bootstrap";
import {
  utilGetSubCollection,
  utilCreateDocument,
  utilGetCollectionFilterReference,
  utilGetMenu,
  getConsecutivoTurnero,
  getFolioVenta,
  utilGetCollectionFilter,
} from "../../../util/UtilsFirebase";
import "./IngresoManual.css";
import ListaPedido from "./ListaPedido";
import Categorias from "./Categorias";
import Platillos from "./Platillos";
import DetalleOrden from "./DetalleOrden";
import { useAuthContext } from "../../../hooks/useAuthContext";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  query,
  setDoc,
  updateDoc,
  where,
} from "firebase/firestore";
import { projectFirestore } from "../../../firebase/config";
import Ticket from "./Ticket";

const IngresoManual = ({ show, handleClose, orden, cajaID, userNew }) => {
  const { register, employee } = useAuthContext();
  const [ordenaGenerar, setOrdenaGenerar] = useState({
    fecha: null,
    number: null,
    user_name: "",
    user: null,
    status: "CAPTURA",
    tipo_pago: "Efectivo",
    total: 0,
    puesto: register.id,
    puesto_name: register.name,
    puesto_img: register.img,
    detalle: [],
  });
  const [nombre, setNombre] = useState("");
  const [anadidosList, setAnadidosList] = useState([]);
  const [ingredientesList, setIngredientesList] = useState([]);
  const [impresion, setImpresion] = useState(false);
  const [data, setData] = useState([]);
  const [visibleCategoria, setVisibleCategoria] = useState(false);
  const [visiblePlatillos, setVisiblePlatillos] = useState(false);
  const [orderDetail, setOrderDetail] = useState([]);
  const [mostrarDetalles, setMostrarDetalles] = useState(false);
  const [modQr, setModQr] = useState(false);
  const [modIngreso, setModIngreso] = useState(false);
  const [platillotoAdd, setPlatillotoAdd] = useState({});
  const [categorias, setCategorias] = useState([]);
  const [menuid, setMenuId] = useState("");
  const [platillosList, setPlatillosList] = useState([]);
  const [metodoPago, setMetodoPago] = useState("Tarjeta");
  const [cobro, setCobro] = useState("0");
  const [cambio, setCambio] = useState("0");
  const [iva, setIva] = useState("0");
  const [puntos, setPuntos] = useState("0");
  const [puntosUsados, setPuntosUsados] = useState("0");
  const [puntosUsuario, setPuntosUsuario] = useState("0");
  const [fecha, setfecha] = useState("");
  const [folio, setfolio] = useState("");
  const [idOrden, setIdOrden] = useState("");
  const [idPuntos, setIdPuntos] = useState("");
  const [empleado, setEmpleado] = useState("");

  //handle control status
  const toggleVisibleCategoria = () => setVisibleCategoria(!visibleCategoria);
  const handleNombre = (nombre) => {
    let ordenaGenerarTmp = ordenaGenerar;
    ordenaGenerarTmp.user_name = nombre;
    setOrdenaGenerar(ordenaGenerarTmp);
    setNombre(nombre);
  };

  const createOrden = async () => {
    const updatedOrderGenerar = {
      ...ordenaGenerar,
      fecha: new Date(),
      number: folio,
      total: calculaCostoTotal(),
      status: "CAPTURA",
      tipo_pago: metodoPago,
      ordenadoPor: "Web Rapdis",
    };
    setOrdenaGenerar(updatedOrderGenerar);
    let id = await utilCreateDocument("turnero", updatedOrderGenerar);
    setIdOrden(id.id);
    if (userNew && userNew !== "") {
      let q = query(collection(projectFirestore, "users"));
      q = query(q, where("id", "==", userNew));
      onSnapshot(q, (docd) => {
        docd.docs.forEach((element) => {
          if (element.exists()) {
            const datos = element.data();
            setNombre(datos["fullName"]);
            setOrdenaGenerar({
              ...ordenaGenerar,
              user: datos["id"],
              user_name: datos["fullName"],
            });
          }
        });
      });
      setModQr(false);
      let p = query(collection(projectFirestore, "puntos"));
      p = query(
        p,
        where("id_usuario", "==", userNew),
        where("id_local", "==", register.id),
      );
      onSnapshot(p, async (docd) => {
        docd.docs.forEach((element) => {
          if (element.exists()) {
            const datos = element.data();
            setPuntosUsuario(datos["puntos"]);
            setIdPuntos(element.id);
          }
        });
        if (docd.empty) {
          let docref = await addDoc(collection(projectFirestore, "puntos"), {
            id_usuario: userNew,
            id_local: register.id,
            puntos: 0,
          });
          setIdPuntos(docref.id);
        }
      });
    } else {
      setPuntosUsuario(0);
      setIdPuntos("");
    }
  };

  const handleClosePedido = () => {
    if (modIngreso) {
      handleCloseLocal();
      if (!orden) {
        deleteDoc(doc(collection(projectFirestore, "turnero"), idOrden))
          .then(() => {
            console.log("Document successfully deleted!");
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
      setOrdenaGenerar({
        fecha: null,
        number: null,
        user_name: "",
        user: null,
        status: "CAPTURA",
        tipo_pago: "Efectivo",
        total: 0,
        puesto: register.id,
        puesto_name: register.name,
        puesto_img: register.img,
        detalle: [],
      });
      setModIngreso(false);
    }
  };

  const handleCloseQr = () => {
    setModIngreso(true);
    setModQr(false);
    setData([]);
  };

  const handleEfectivo = (cantidad) => {
    if (cantidad === "") {
      cantidad = 0;
    }
    let Cambio =
      calculaCostoTotal() -
      parseFloat(cantidad) -
      puntos *
        (register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0);
    if (orden) {
      Cambio =
        Cambio -
        (orden.cobro ? parseFloat(orden.cobro) : 0) +
        (orden.cambio ? parseFloat(orden.cambio) : 0);
    }
    setCambio(-Cambio.toFixed(2));
    setCobro(cantidad);
  };

  const handlePuntos = (cantidad) => {
    let puntosTt = parseFloat(cantidad) + parseFloat(puntosUsados);
    setPuntos(puntosTt);
    let Cambio =
      calculaCostoTotal() -
      cobro -
      cantidad *
        (register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0);
    if (orden) {
      Cambio =
        Cambio -
        (orden.cobro ? parseFloat(orden.cobro) : 0) +
        (orden.cambio ? parseFloat(orden.cambio) : 0);
    }
    setCambio(-Cambio.toFixed(2));
    setCobro(cobro);
    calculaCostoTotal();
  };

  const ChangeQr = (e) => {
    var qrText = "https://quickchart.io/qr?text=TID-" + e;
    var info = {
      id: 1,
      nombre: "QR Pedido",
      qr: qrText,
    };
    setData([info]);
  };

  const handleCambio = () => {
    let Cambio =
      calculaCostoTotal() -
      cobro -
      puntos *
        (register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0);
    if (orden) {
      Cambio =
        Cambio -
        (orden.cobro ? parseFloat(orden.cobro) : 0) +
        (orden.cambio ? parseFloat(orden.cambio) : 0);
    }
    setCambio(Cambio.toFixed(2));
  };

  const toggleVisiblePlatillos = (categoria) => {
    console.log("toggle", categoria);
    setVisiblePlatillos(!visiblePlatillos);
    setVisibleCategoria(!visibleCategoria);
    if (categoria !== undefined && categoria != null) fetchPlatillos(categoria);
  };

  const handleCloseLocal = async () => {
    if (orden) {
      handleClose(ordenaGenerar);
    } else {
      handleClose();
    }
    setNombre("");
    setModIngreso(false);
    setMetodoPago("Tarjeta");
    setCobro(0);
    setPuntos(0);
    setCambio(0);
    setCategorias([]);
    setOrdenaGenerar({
      fecha: null,
      number: null,
      user_name: "",
      user: null,
      status: "CAPTURA",
      tipo_pago: "Efectivo",
      total: 0,
      puesto: register.id,
      puesto_name: register.name,
      puesto_img: register.img,
      detalle: [],
    });
    setVisibleCategoria(false);
    setVisiblePlatillos(false);
    setOrderDetail([]);
    setIdPuntos("");
    setMostrarDetalles(false);
    setPlatillotoAdd({});
  };

  const PlatilloSelected = (platillo) => {
    setPlatillotoAdd(platillo);
    setMostrarDetalles(true);
  };

  const handleRemovePlatillo = (itemtoRemove) => {
    const newOrderDetail = orderDetail.filter((item) => item !== itemtoRemove);
    setOrderDetail(newOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: newOrderDetail,
    });
  };

  const calculaCostoTotal = () => {
    let suma = 0;
    for (let i = 0; i < orderDetail.length; i++) {
      suma +=
        parseFloat(orderDetail[i].total) +
        parseFloat(orderDetail[i].totalAnadidos);
    }
    return suma;
  };

  const calcularPuntosTotal = () => {
    let suma = 0;
    if (register.Tpuntos) {
      for (let i = 0; i < orderDetail.length; i++) {
        if (orderDetail[i].puntos) {
          suma += parseFloat(orderDetail[i].puntos);
        }
      }
    }
    return suma;
  };

  const ChangeMetPag = (e) => {
    if (e.target.value === "Efectivo") {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.removeAttribute("hidden");
    } else {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.hidden = true;
    }
    setMetodoPago(e.target.value);
  };

  const fetchPlatillos = async (categoria) => {
    try {
      const menu = await utilGetMenu(menuid);
      console.log("Menu to fetch: " + categoria.id);
      let platillosFiltered = menu.platillo.filter(
        (platillo) =>
          platillo.categoria && platillo.categoria.id === categoria.id,
      );
      let q = query(collection(projectFirestore, "menu", menuid, "anadidos"));
      q = query(q, where("categorias", "array-contains", categoria.name));
      onSnapshot(q, async (docd) => {
        let collection = [];
        docd.docs.forEach((element) => {
          if (element.exists()) {
            let datos = element.data();
            datos.id = element.id;
            collection.push(datos);
          }
        });
        setAnadidosList(collection);
        console.log(collection);
      });
      setPlatillosList(platillosFiltered);
    } catch (error) {
      console.error("Error fetching platillos:", error);
    }
    try {
      const menu = await utilGetMenu(menuid);
      console.log("Menu to fetch: " + categoria.id);
      let platillosFiltered = menu.platillo.filter(
        (platillo) =>
          platillo.categoria && platillo.categoria.id === categoria.id,
      );
      let q = query(
        collection(projectFirestore, "menu", menuid, "ingredientes"),
      );
      q = query(q, where("categorias", "array-contains", categoria.name));
      onSnapshot(q, async (docd) => {
        let collection = [];
        docd.docs.forEach((element) => {
          if (element.exists()) {
            let datos = element.data();
            datos.id = element.id;
            collection.push(datos);
          }
        });
        setIngredientesList(collection);
        console.log(collection);
      });
      setPlatillosList(platillosFiltered);
    } catch (error) {
      console.error("Error fetching platillos:", error);
    }
    try {
      const menu = await utilGetMenu(menuid);
      console.log("Menu to fetch: " + categoria.id);
      let platillosFiltered = menu.platillo.filter(
        (platillo) =>
          platillo.categoria && platillo.categoria.id === categoria.id,
      );
      setPlatillosList(platillosFiltered);
    } catch (error) {
      console.error("Error fetching anadidos:", error);
    }
  };

  const handleBackPlatillos = () => {
    setMostrarDetalles(false);
    toggleVisiblePlatillos(null);
  };

  const anadirALista = (platilloDetalle) => {
    const updatedOrderDetail = [...orderDetail, platilloDetalle];
    setOrderDetail(updatedOrderDetail);
    setOrdenaGenerar({
      ...ordenaGenerar,
      detalle: updatedOrderDetail,
    });
    handleCambio();
  };

  const ShowModal = () => {
    if (metodoPago === "Efectivo") {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.removeAttribute("hidden");
    } else {
      let DivEfect = document.getElementById("divEfect");
      DivEfect.hidden = true;
    }
  };

  const mandarOrden = async (impres) => {
    if (metodoPago === "Efectivo" && cambio < 0) {
      alert("Aun faltan " + -cambio);
      return;
    }
    if (!nombre || nombre.trim() === "") {
      alert("Ingrese un nombre");
      return;
    }
    if (orderDetail.length <= 0) {
      alert("Seleccione al menos un platillo.");
      return;
    }
    const confirmVal = window.confirm(
      !orden
        ? "¿Estás seguro de que deseas generar el turno?"
        : "¿Estás seguro de que deseas actualizar la informacion?",
    );
    if (confirmVal && !orden) {
      const numero = await getConsecutivoTurnero(register.id);
      const updatedOrderGenerar = {
        ...ordenaGenerar,
        fecha: new Date(),
        folio: folio,
        number: numero,
        total: calculaCostoTotal(),
        status: "ATENDIDO",
        tipo_pago: metodoPago,
        tipo_venta: "Mostrador",
        caja: cajaID,
        equivalenciapuntos: register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0,
        ordenadoPor: "Web Rapdis",
        puntosusados: puntos,
        puntosgenerados: calcularPuntosTotal(),
        iva: iva,
        cobroiva: calculaCostoTotal() - calculaCostoTotal() / (1 + iva / 100),
      };
      if (employee !== undefined) {
        updatedOrderGenerar.atendio = employee.id_usuario;
      } else {
        updatedOrderGenerar.atendio = "Administrador";
      }
      if (metodoPago === "Tarjeta") {
        updatedOrderGenerar.cobro =
          calculaCostoTotal() -
          puntos *
            (register.equivalenciapuntos
              ? parseFloat(register.equivalenciapuntos)
              : 0);
        updatedOrderGenerar.cambio = 0;
      } else {
        updatedOrderGenerar.cobro = cobro;
        updatedOrderGenerar.cambio = cambio;
      }
      if (idPuntos) {
        updatedOrderGenerar.reclamados = true;
      } else {
        updatedOrderGenerar.reclamados = false;
      }
      setOrdenaGenerar(updatedOrderGenerar);
      await utilCreateDocument("turnero", updatedOrderGenerar);
      if (idPuntos) {
        if (puntos > 0) {
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion: "Se usaron " + puntos + " puntos",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        }
        if (calcularPuntosTotal() > 0) {
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion: "Obtuviste " + calcularPuntosTotal() + " puntos",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        }
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: ordenaGenerar.user,
          id_local: register.id,
          puntos:
            puntosUsuario -
            parseFloat(puntos) +
            parseFloat(calcularPuntosTotal()),
        });
      }
      updatedOrderGenerar.detalle.forEach(async (itemdet) => {
        if (itemdet?.id && itemdet?.selectedDate) {
          const documplat = doc(
            projectFirestore,
            "menu",
            menuid,
            "platillo",
            itemdet.id,
          );
          if (itemdet?.selectedDate && itemdet?.selectedTime) {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedTime] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedTime] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedTime] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedTime]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedTime]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, {
              fechas: dispo2,
              reservados: dispo3,
            });
          } else {
            const dataplat = (await getDoc(documplat)).data();
            let dispo3 = { ...dataplat?.reservados };
            if (
              dispo3 &&
              dispo3[itemdet?.selectedDate] &&
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo3[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo3[itemdet?.selectedDate][itemdet?.selectedDate] -
                itemdet?.cantidad;
            }
            let dispo2 = { ...dataplat?.fechas };
            if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2[itemdet?.selectedDate][itemdet?.selectedDate] =
                dispo2[itemdet?.selectedDate][itemdet?.selectedDate] +
                itemdet?.cantidad;
            } else if (
              dispo2 &&
              dispo2[itemdet?.selectedDate] &&
              !dispo2[itemdet?.selectedDate][itemdet?.selectedDate]
            ) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  ...dispo2[itemdet?.selectedDate],
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else if (dispo2 && !dispo2[itemdet?.selectedDate]) {
              dispo2 = {
                ...dispo2,
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            } else {
              dispo2 = {
                [itemdet?.selectedDate]: {
                  [itemdet?.selectedDate]: itemdet?.cantidad,
                },
              };
            }
            updateDoc(documplat, {
              fechas: dispo2,
              reservados: dispo3,
            });
          }
        }
      });
      if (impres === true) {
        setImpresion(true);
      } else {
        setImpresion(false);
        // alert("Se genero el turno: " + numero + ".");
        handleCloseLocal();
      }
      return [updatedOrderGenerar];
    } else if (confirmVal && orden) {
      const updatedOrderGenerar = {
        ...ordenaGenerar,
        fecha: new Date(),
        total: calculaCostoTotal(),
        status: "ATENDIDO",
        tipo_pago: metodoPago,
        tipo_venta: "Mostrador",
        equivalenciapuntos: register.equivalenciapuntos
          ? parseFloat(register.equivalenciapuntos)
          : 0,
        ordenadoPor: "Web Rapdis",
        puntosusados: puntos,
        puntosgenerados: calcularPuntosTotal(),
        iva: iva,
        cobroiva: calculaCostoTotal() - calculaCostoTotal() / (1 + iva / 100),
      };
      if (employee !== undefined) {
        updatedOrderGenerar.atendio = employee.id_usuario;
      } else {
        updatedOrderGenerar.atendio = "Administrador";
      }
      if (metodoPago === "Tarjeta") {
        updatedOrderGenerar.cobro =
          calculaCostoTotal() -
          puntos *
            (register.equivalenciapuntos
              ? parseFloat(register.equivalenciapuntos)
              : 0);
        updatedOrderGenerar.cambio =
          parseFloat(cambio) + (orden.cambio ? parseFloat(orden.cambio) : 0);
      } else {
        updatedOrderGenerar.cobro =
          parseFloat(cobro) + (orden.cobro ? parseFloat(orden.cobro) : 0);
        updatedOrderGenerar.cambio =
          parseFloat(cambio) + (orden.cambio ? parseFloat(orden.cambio) : 0);
      }
      if (idPuntos) {
        updatedOrderGenerar.reclamados = true;
      } else {
        updatedOrderGenerar.reclamados = false;
      }
      setDoc(doc(projectFirestore, "turnero", orden.id), updatedOrderGenerar);
      setOrdenaGenerar(updatedOrderGenerar);
      if (idPuntos) {
        let gen =
          parseFloat(calcularPuntosTotal()) -
          parseFloat(orden.puntosgenerados ? orden.puntosgenerados : 0);
        let usa = parseFloat(puntos) - parseFloat(orden.puntosusados);
        setDoc(doc(projectFirestore, "puntos", idPuntos), {
          id_usuario: ordenaGenerar.user,
          id_local: register.id,
          puntos: puntosUsuario - usa + gen,
        });
        if (gen > 0) {
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion: "Obtuviste " + gen + " puntos",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        } else if (gen < 0) {
          gen = -gen;
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion:
                "Perdiste: " + gen + " en la modificacion de tu orden",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        }
        if (usa > 0) {
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion: "Se usaron " + usa + " puntos",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        } else if (usa < 0) {
          usa = -usa;
          addDoc(
            collection(projectFirestore, "puntos", idPuntos, "historial"),
            {
              descripcion: "Recuperaste " + usa + " puntos",
              fecha: new Date(),
              folioOrden: folio,
            },
          );
        }
      }
      if (impres) {
        setImpresion(true);
      } else {
        setImpresion(false);
        // alert("Se actualizo la orden: " + orden.number + ".");
        handleCloseLocal();
      }
      console.log(updatedOrderGenerar);
      return [updatedOrderGenerar];
    }
  };

  useEffect(() => {
    if (employee !== undefined) {
      const personal = utilGetCollectionFilter(
        "users",
        "id",
        "==",
        employee.id_usuario,
      );
      personal.then((result) => {
        setEmpleado(result[0]);
      });
    }
    const fetchCategorias = async () => {
      try {
        const menu = await utilGetCollectionFilterReference(
          "menu",
          "registro",
          "==",
          register.id,
          "registro",
        );
        let menuId = menu[0].id;
        const categorias = await utilGetSubCollection(
          "menu",
          menuId,
          "categoria",
        );
        setMenuId(menuId);
        setCategorias(categorias);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    const folioV = async () => {
      let ds = await getFolioVenta(register.id);
      setfolio(ds.count);
    };
    if (show && !modIngreso) {
      setImpresion(false);
      if (!orden) {
        setModIngreso(true);
        folioV();
        createOrden();
      } else {
        setModIngreso(true);
        setOrdenaGenerar(orden);
        setOrderDetail(orden.detalle);
        setNombre(orden.user_name);
        setPuntosUsados(orden.puntosusados);
        setfolio(orden.folio);
        console.log(orden);
        if (orden.user) {
          let p = query(collection(projectFirestore, "puntos"));
          p = query(
            p,
            where("id_usuario", "==", orden.user),
            where("id_local", "==", register.id),
          );
          onSnapshot(p, async (docd) => {
            docd.docs.forEach((element) => {
              if (element.exists()) {
                const datos = element.data();
                setPuntosUsuario(datos["puntos"]);
                setIdPuntos(element.id);
              }
            });
            if (docd.empty) {
              let docref = await addDoc(
                collection(projectFirestore, "puntos"),
                {
                  id_usuario: orden.user,
                  id_local: register.id,
                  puntos: 0,
                },
              );
              setIdPuntos(docref.id);
            }
          });
        } else {
          setPuntosUsuario(0);
          setIdPuntos("");
        }
      }
      fetchCategorias();
      setInterval(() => {
        setfecha(
          new Date().toLocaleDateString() +
            " " +
            new Date().toLocaleTimeString(),
        );
      }, 1000);
    }
    if (register.frontera) {
      setIva(16);
    } else {
      setIva(8);
    }
  }, [
    employee,
    modIngreso,
    ordenaGenerar,
    register.frontera,
    register.id,
    show,
    iva,
    orden,
  ]);

  return (
    <div>
      <Modal
        show={modIngreso}
        onHide={handleClosePedido}
        onExit={handleClosePedido}
        onShow={ShowModal}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>INGRESO MANUAL</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <br />
            <Row>
              <Col xs={7} md={7} lg={7} xl={7}>
                <Form>
                  <Form.Group controlId="formName" style={{ marginBottom: 15 }}>
                    <Form.Label>Nombre</Form.Label>
                    <Form.Control
                      type="text"
                      value={nombre}
                      placeholder="Ingresa tu nombre"
                      onChange={(e) => handleNombre(e.target.value)}
                    />
                  </Form.Group>
                  <div className="center">
                    {!visibleCategoria && !visiblePlatillos && (
                      <Form.Group controlId="formName">
                        <Button
                          variant="primary"
                          size="lg"
                          onClick={toggleVisibleCategoria}
                        >
                          MENÚ
                        </Button>
                      </Form.Group>
                    )}
                    {visibleCategoria && !visiblePlatillos && (
                      <Container>
                        <Row>
                          {categorias.map((card, index) => (
                            <Categorias
                              card={card}
                              index={index}
                              key={card.id}
                              toggleVisiblePlatillos={() =>
                                toggleVisiblePlatillos(card)
                              }
                              clicked={fetchPlatillos}
                            />
                          ))}
                        </Row>
                        <Form.Group controlId="formName">
                          <Button
                            variant="primary"
                            size="xs"
                            onClick={toggleVisibleCategoria}
                          >
                            CERRAR
                          </Button>
                        </Form.Group>
                      </Container>
                    )}
                    {visiblePlatillos && (
                      <Container>
                        {mostrarDetalles ? (
                          <DetalleOrden
                            plati={platillotoAdd}
                            anadirPedido={anadirALista}
                            anadidos={anadidosList}
                            ingredientes={ingredientesList}
                            handlebackPlatillos={handleBackPlatillos}
                            detalleOrden={orderDetail}
                          />
                        ) : (
                          <>
                            <Row>
                              {platillosList.map((card, index) => (
                                <Platillos
                                  index={index}
                                  card={card}
                                  returnSelected={PlatilloSelected}
                                  detalleOrden={orderDetail}
                                />
                              ))}
                            </Row>
                            <Form.Group controlId="formName">
                              <Button
                                variant="primary"
                                size="xs"
                                onClick={toggleVisiblePlatillos}
                              >
                                CERRAR
                              </Button>
                            </Form.Group>
                          </>
                        )}
                      </Container>
                    )}
                  </div>
                </Form>
              </Col>
              <Col md={5}>
                <h5 className="center">Folio de venta: {folio}</h5>
                <br />
                <h5>Fecha y hora: {fecha}</h5>
                <br />
                <h5>Tipo de venta: Mostrador</h5>
                <br />
                <h5>
                  Atendido por:{" "}
                  {employee !== undefined ? empleado.fullName : "Administrador"}
                </h5>
                <br />
                <ListaPedido
                  items={orderDetail}
                  total={calculaCostoTotal()}
                  handleRemove={handleRemovePlatillo}
                  puntos={puntos}
                  equivalenciapuntos={
                    register.equivalenciapuntos
                      ? parseFloat(register.equivalenciapuntos)
                      : 0
                  }
                  cols={12}
                  iva={iva}
                  puntosGenerados={calcularPuntosTotal()}
                />
                <div id="divPuntos">
                  <Form.Group controlId="formName">
                    <Form.Label>
                      {parseFloat(puntosUsuario) > 0 ? (
                        <>
                          Cuentas con {puntosUsuario} puntos <br />
                        </>
                      ) : (
                        <></>
                      )}
                      Puntos a usar:
                    </Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="0"
                      onInput={(e) => {
                        e.preventDefault();
                      }}
                      onBeforeInput={(e) => {
                        e.preventDefault();
                      }}
                      max={puntosUsuario}
                      min={0}
                      pattern="[0-9]{0,13}"
                      autoComplete="off"
                      onChange={(e) => handlePuntos(e.target.value)}
                    />
                  </Form.Group>
                </div>
                <Form.Group controlId="type">
                  <label className="center"> Metodo de pago</label>
                  <select
                    value={metodoPago}
                    onChange={(e) => {
                      ChangeMetPag(e);
                    }}
                  >
                    <option value={"Tarjeta"}>Tarjeta</option>
                    <option value={"Efectivo"}>Efectivo</option>
                  </select>
                </Form.Group>
                <div id="divEfect" hidden>
                  <Form.Group controlId="formName">
                    <Form.Label>Se cobro</Form.Label>
                    <Form.Control
                      type="number"
                      placeholder="0.00"
                      pattern="[0-9]{0,13}"
                      min={0}
                      autoComplete="off"
                      onChange={(e) => handleEfectivo(e.target.value)}
                    />
                  </Form.Group>
                  <label>
                    {cambio < 0 ? "Faltan :" : "Cambio: "} {cambio} $
                  </label>
                </div>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClosePedido}>
            CANCELAR
          </Button>
          <Button variant="primary" onClick={mandarOrden}>
            COBRAR
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              mandarOrden(true);
            }}
          >
            COBRAR E IMPRIMIR
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <Modal show={modQr} onExit={handleCloseQr} onShow={createOrden}>
        <ModalHeader>Vincular orden</ModalHeader>
        <ModalBody>
          Escanee el QR desde su aplicacion para vincular
          <div id="project-qr" className="row">
            <div className="col-sm-12">
              {data.map((n, key) => (
                <div key={key} className="center">
                  <img
                    className="qr-code"
                    style={{
                      width: "100px !important",
                      height: "100px !important",
                    }}
                    src={n.qr}
                    alt=""
                  ></img>
                </div>
              ))}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="secondary"
            onClick={() => {
              setModQr(false);
            }}
          >
            CONTINUAR SIN ENLAZAR
          </Button>
        </ModalFooter>
      </Modal> */}
      <Ticket
        orden={ordenaGenerar}
        registro={register}
        impresion={impresion}
        handleClose={handleCloseLocal}
        setImpresion={setImpresion}
      />
    </div>
  );
};

export default IngresoManual;
